import {ArrowUpRight} from 'lucide-react'
import FadeIn from '@/components/FadeIn'

const CASES = [
  {
    tag: 'SEO',
    title: 'Сеть стоматологических клиник в Москве',
    result: 'Рост органического трафика на 180% и увеличение количества заявок на прием в 2 раза за 8 месяцев',
  },
  {
    tag: 'SEO + GEO',
    title: 'Интернет-магазин мебели «МосМебельПром»',
    result: 'Выход в топ-10 Яндекс и Google по 120 коммерческим запросам, упоминания в ответах нейросетей по подбору мебели',
  },
  {
    tag: 'GEO',
    title: 'Юридическая компания по банкротству физлиц',
    result: 'Бренд стал попадать в ответы ChatGPT и Perplexity по запросам о списании долгов, рост звонков с сайта на 65%',
  },
  {
    tag: 'SEO',
    title: 'Сеть автосервисов в Москве и области',
    result: 'Локальный SEO вывел филиалы в топ карт и поиска, рост записей на ремонт на 90% за год',
  },
  {
    tag: 'SEO + реклама',
    title: 'Онлайн-школа английского языка',
    result: 'Снижение стоимости заявки на 40% за счет связки SEO-трафика и контекстной рекламы',
  },
  {
    tag: 'SEO + GEO',
    title: 'Клиника пластической хирургии',
    result: 'Рост позиций по конкурентным медицинским запросам и появление в рекомендациях AI-ассистентов при выборе клиники',
  },
  {
    tag: 'SEO',
    title: 'Производитель и продавец окон «ОкнаСтройМонтаж»',
    result: 'Увеличение органических заявок с сайта в 2,3 раза, снижение зависимости от платной рекламы',
  },
  {
    tag: 'GEO',
    title: 'Сервис доставки корпоративного питания',
    result: 'Настройка присутствия бренда в ответах нейросетей на запросы про доставку обедов в офис, рост B2B-заявок на 50%',
  },
]

function Cases() {
  return (
    <section id="cases" className="bg-neutral-950 py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <FadeIn className="max-w-2xl">
          <span className="text-sm font-semibold uppercase tracking-widest text-emerald-400">
            Результаты
          </span>
          <h2 className="mt-3 text-3xl font-black tracking-tight text-white sm:text-4xl">
            Кейсы успешных проектов
          </h2>
        </FadeIn>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2">
          {CASES.map((item, index) => (
            <FadeIn
              key={item.title}
              delay={index * 60}
              className="group relative overflow-hidden rounded-2xl border border-neutral-800 bg-neutral-900/40 p-7 transition-colors hover:border-emerald-400/40"
            >
              <div className="flex items-start justify-between gap-4">
                <span className="rounded-full border border-neutral-700 px-3 py-1 text-xs font-semibold text-emerald-300">
                  {item.tag}
                </span>
                <ArrowUpRight className="h-5 w-5 text-neutral-600 transition-colors group-hover:text-emerald-400" />
              </div>
              <h3 className="mt-5 text-lg font-bold leading-snug text-white">{item.title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-neutral-400">{item.result}</p>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Cases
